type SessionStorageKeyType =
  | 'welcomeModalDismissed'
  | 'companyNudgeDismissed'
  | 'companyNudgeSeen'

/**
 * Session storage, kept for the current browser session only. Falls back to
 * memory when the browser blocks it (e.g. private mode), like localStorageUtils.
 */
class SessionStorageUtils {
  private memory: Record<string, unknown> = {}

  setItem<T>(key: SessionStorageKeyType, value: T): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      this.memory[key] = value
    }
  }

  getItem<T>(key: SessionStorageKeyType): T | null {
    try {
      const item = sessionStorage.getItem(key)
      if (item === null) {
        return null
      }
      return JSON.parse(item) as T
    } catch (error) {
      return (this.memory[key] as T) ?? null
    }
  }
}

export default new SessionStorageUtils()
